module.exports = __webpack_public_path__ + "static/media/payment-methods.a1e50015.png";